import React from "react";
import { Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

import Page from "src/components/Page";
import Header from "./Header";
import MperitoCard from "src/components/MperitoCard";
import VariantOptionsEditForm from "./VariantOptionsEditForm";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: 100,
  },
}));

function VariantOptionsEdit() {
  const classes = useStyles();
  const { state } = useLocation();

  const businessInfo = useSelector(
    (state) => state?.app?.businessInfo
  );

  const customerId = businessInfo?.customerId;

  return (
    <Page
      className={classes.root}
    >
      <Container maxWidth="lg">
        <Header />

        <MperitoCard
          title={`Edit Variant Option ( ${businessInfo?.businessName} - ${businessInfo?.customerId} )`}
        >
          <VariantOptionsEditForm
            customerId={customerId}
            data={state}
          />
        </MperitoCard>
      </Container>
    </Page>
  );
}

export default VariantOptionsEdit;